import React from 'react';

export function svgToIcon(svgFile) {
  // We use this pattern of putting the SVG as inner HTML so that the color
  // of the SVG is controlled by the font color.

  return (
    <i
      className="fa-regular"
      style={{ lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: svgFile }}
    />
  );
}
